import dataStore, { adapter } from "../store";
import axios from "axios";
import userHub from "@/services/hubs/user";
import Cookies from 'js-cookie'

const USER_TOKEN_KEY = "user";
const AUTH_LOGIN = `${process.env.VUE_APP_API_HOST}api-token-auth/`;

const domain = `.habittechnologies.${location.origin.split(".")[2]}`;

class AuthUser {
  constructor() {
    this.user = {};
    this.token = "";
    try {
      this.getTokenInfoFromStorage();
    } catch (err) {
      return;
    }
  }

  get impersonating() {
    return !!localStorage.getItem("impersonating");
  }

  getTokenInfoFromStorage() {
    let serializedData = localStorage.getItem(USER_TOKEN_KEY);
    if (!serializedData) {
      serializedData = Cookies.get(USER_TOKEN_KEY), { domain } ;
    }

    let { token, id } = JSON.parse(serializedData);
    this.id = id;
    this.token = token;
    this.setAuthHeader(token);
    this._login({ token, id }) // ensures cookies or local storage is always set
    return { token, id };
  }

  async getUserFromStorage() {
    try {
      const { id } = this.getTokenInfoFromStorage();
      return this.getUser(id);
    } catch (e) {
      throw e;
    }
  }

  isLoggedIn() {
    try {
      const { id } = this.getTokenInfoFromStorage();
      this.getUser(id);
    } catch (e) {
      return false;
    }
    return true;
  }

  setAuthHeader(token) {
    token = token.trim();
    axios.defaults.headers.common.Authorization = `Token ${token}`;
    adapter.http.defaults.headers.common.Authorization = `Token ${token}`;
  }

  async getUser(userId, bypassCache = false) {
    userId = userId || this.id;
    this.loggedInPromise =
      this.loggedInPromise && !bypassCache
        ? this.loggedInPromise
        : new Promise((resolve, reject) => {
            dataStore
              .find("User", userId)
              .then(data => {
                this.user = data;
                Object.assign(this, this.user);
                resolve(this.user);
                userHub.update(this.user);
              })
              .catch(e => {
                this.logout()
                reject(e);
                this.loggedInPromise = undefined;
              });
          });
    return this.loggedInPromise;
  }

  async login({ email, password }) {
    this.logout();
    let response;
    try {
      response = await axios.post(AUTH_LOGIN, {
        username: email,
        password: password
      });
    } catch (e) {
      throw e.response;
    }

    let data = response.data;
    // axios.post(PUSH_NOTIFICATION_URL, this.notificationInfo)
    //     .catch((r) => {}); // this will probably fail most of the time but that's expected
    return this._login(data).catch(e => {
      throw Error({status: 410})
    })
  }

  _login(data) {
    localStorage.setItem(USER_TOKEN_KEY, JSON.stringify(data));
    Cookies.set(USER_TOKEN_KEY, JSON.stringify(data), { domain } );
    let { token, id } = data;
    this.setAuthHeader(token);
    return this.getUser(id);
  }

  async setOnBoarded() {
    this.user.onboarded = true;
    this.onboarded = true;
    return dataStore.update(
      "User",
      this.id,
      { onboarded: true },
      { method: "PATCH" }
    );
  }

  logout() {
    this.user = undefined;
    this.loggedInPromise = undefined;
    this.id = undefined;
    adapter.http.defaults.headers.common.Authorization = undefined;
    localStorage.removeItem(USER_TOKEN_KEY);
    userHub.update({});
    localStorage.removeItem("impersonating");
    Cookies.remove(USER_TOKEN_KEY, { domain });
  }

  resetPassword(email) {
    return dataStore
      .getMapper("User")
      .passwordChange({ data: { email } })
      .catch(({ response }) => {
        throw response;
      });
  }

  impersonate(email) {
    return axios.post(`${process.env.VUE_APP_API_URL}user/impersonate/`, { email })
      .then(({ data }) => {
        this._login(data);
        localStorage.setItem("impersonating", true);
      });
  }

  save(data) {
    return dataStore.update("User", this.user.id, data, { method: "patch" }).then(() => {
      Object.assign(this, data);
      Object.assign(this.user, data);
    });
  }

  hasPermission(feature) {
    if (!this.features || !this.isLoggedIn()) {
      return false;
    }
    let { client_features, coach_features } = this.features;
    let features = [...client_features, ...coach_features];
    return features.includes('all') || features.includes(feature);
  }
}

export default new AuthUser();
